import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, Link } from 'react-router-dom';
import api from '../../services/api';
import './Sidebar.scss';

interface SidebarProps {
  collapsed: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed }) => {
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState(0);

  const fetchPendingCount = useCallback(async () => {
    try {
      const res = await api.get('/admin/pending/counts');
      setPendingCount(res.data.data?.total || 0);
    } catch { /* silent */ }
  }, []);

  useEffect(() => {
    fetchPendingCount();
    const interval = setInterval(fetchPendingCount, 30000);
    return () => clearInterval(interval);
  }, [fetchPendingCount]);

  const menuItems = [
    {
      path: '/pending',
      label: 'Laukia patvirtinimo',
      shortLabel: 'Tvirt.',
      badge: pendingCount > 0 ? pendingCount : undefined
    },
    {
      path: '/users',
      label: 'Naudotojai',
      shortLabel: 'Naud.'
    },
    {
      path: '/jobs',
      label: 'Darbo skelbimai',
      shortLabel: 'Darb.'
    },
    {
      path: '/cvs',
      label: 'CV valdymas',
      shortLabel: 'CV'
    },
    {
      path: '/cv-templates',
      label: 'CV šablonai',
      shortLabel: 'Šabl.'
    },
    {
      path: '/taxonomy',
      label: 'Taksonomija',
      shortLabel: 'Taks.'
    },
    {
      path: '/companies',
      label: 'Įmonės',
      shortLabel: 'Įmon.'
    },
    {
      path: '/services',
      label: 'Paslaugos',
      shortLabel: 'Pasl.'
    },
    {
      path: '/discount-codes',
      label: 'Nuolaidų kodai',
      shortLabel: 'Nuol.'
    },
    {
      path: '/orders',
      label: 'Užsakymai',
      shortLabel: 'Užs.'
    },
    {
      path: '/analytics',
      label: 'Analitika',
      shortLabel: 'Anal.'
    },
    {
      path: '/settings',
      label: 'Nustatymai',
      shortLabel: 'Nust.'
    }
  ];

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <div className="brand">
          <div className="logo">
            <img src="/logo.png" alt="Gidas.lt" />
          </div>
          {!collapsed && (
            <div className="brand-text">
              <h2>Gidas.lt</h2>
              <span>Admin</span>
            </div>
          )}
        </div>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item: any) => (
            <li key={item.path} className="nav-item">
              <Link
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                title={collapsed ? item.label : undefined}
              >
                <span className="nav-label">
                  {collapsed ? item.shortLabel : item.label}
                </span>
                {item.badge != null && item.badge > 0 && (
                  <span className="nav-badge">{item.badge}</span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
